module.exports = __webpack_public_path__ + "img/feature-innovate-icon.ab48e872.svg";